import React from "react";
import { Drawer, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import CarIcon from "@mui/icons-material/DirectionsCar";
import PersonIcon from "@mui/icons-material/Person";
import BuildIcon from "@mui/icons-material/Build";
import LocalGasStationIcon from "@mui/icons-material/LocalGasStation";
import TimerIcon from "@mui/icons-material/Timer";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import FolderIcon from '@mui/icons-material/Folder';

const Sidebar = () => {

    const location = useLocation();
    
    return (
        <>
            {/* Sidebar Drawer */}
            <Drawer
                sx={{
                    width: 240,
                    marginLeft: '-8px',
                    flexShrink: 0,
                    "& .MuiDrawer-paper": {
                        width: 240,
                        boxSizing: "border-box",
                        backgroundColor: "white", // White background for the sidebar
                        color: "black", // Black text color by default
                        marginTop: "64px",
                    },
                }}
                variant="permanent"
            >
                <List>
                    {/* Tablero */}
                    <ListItem
                        button
                        component={Link}
                        to="/"
                        sx={{
                            cursor: "pointer",
                            background: location.pathname === "/" ? "#152d51" : "transparent", // Dark blue if active
                            "&:hover": {
                                backgroundColor: "#152d51", // Dark blue on hover
                                color: "white", // White text on hover
                            },
                            color: location.pathname === "/" ? "white" : "black", // White text if active, black otherwise
                            borderRadius: "8px", // Optional: rounded corners
                            marginBottom: "8px", // Margin between items
                            width: "80%", // Optional: to create some width for the items
                            marginLeft: "auto", // Centers the item
                            marginRight: "auto", // Centers the item
                            "&:hover .MuiSvgIcon-root": { // Ensure the icon turns white on hover
                                color: "white",
                            },
                        }}
                    >
                        <ListItemIcon>
                            <SpaceDashboardIcon sx={{ color: location.pathname === "/" ? "white" : "inherit" }} /> {/* White icon if active */}
                        </ListItemIcon>
                        <ListItemText primary="Tablero" sx={{ color: "inherit" }} />
                    </ListItem>

                    {/* Vehículos */}
                    <ListItem
                        button
                        component={Link}
                        to="/vehiculos"
                        sx={{
                            cursor: "pointer",
                            background: location.pathname === "/vehiculos" ? "#152d51" : "transparent", // Dark blue if active
                            "&:hover": {
                                backgroundColor: "#152d51", // Dark blue on hover
                                color: "white", // White text on hover
                            },
                            color: location.pathname === "/vehiculos" ? "white" : "black", // White text if active, black otherwise
                            borderRadius: "8px", // Optional: rounded corners
                            marginBottom: "8px", // Margin between items
                            width: "80%", // Optional: to create some width for the items
                            marginLeft: "auto", // Centers the item
                            marginRight: "auto", // Centers the item
                            "&:hover .MuiSvgIcon-root": { // Ensure the icon turns white on hover
                                color: "white",
                            },
                        }}
                    >
                        <ListItemIcon>
                            <CarIcon sx={{ color: location.pathname === "/vehiculos" ? "white" : "inherit" }} /> {/* White icon if active */}
                        </ListItemIcon>
                        <ListItemText primary="Vehículos" sx={{ color: "inherit" }} />
                    </ListItem>

                    {/* Conductores */}
                    <ListItem
                        button
                        component={Link}
                        to="/conductores"
                        sx={{
                            cursor: "pointer",
                            background: location.pathname === "/conductores" ? "#152d51" : "transparent",
                            "&:hover": {
                                backgroundColor: "#152d51", // Dark blue on hover
                                color: "white", // White text on hover
                            },
                            color: location.pathname === "/conductores" ? "white" : "black", // White text if active
                            borderRadius: "8px", // Optional: rounded corners
                            marginBottom: "8px", // Margin between items
                            width: "80%", // Optional: to create some width for the items
                            marginLeft: "auto", // Centers the item
                            marginRight: "auto", // Centers the item
                            "&:hover .MuiSvgIcon-root": { // Ensure the icon turns white on hover
                                color: "white",
                            },
                        }}
                    >
                        <ListItemIcon>
                            <PersonIcon sx={{ color: location.pathname === "/conductores" ? "white" : "inherit" }} /> {/* White icon if active */}
                        </ListItemIcon>
                        <ListItemText primary="Conductores" sx={{ color: "inherit" }} />
                    </ListItem>

                    {/* Mantenimiento */}
                    <ListItem
                        button
                        component={Link}
                        to="/mantenimiento"
                        sx={{
                            cursor: "pointer",
                            background: location.pathname === "/mantenimiento" ? "#152d51" : "transparent",
                            "&:hover": {
                                backgroundColor: "#152d51", // Dark blue on hover
                                color: "white", // White text on hover
                            },
                            color: location.pathname === "/mantenimiento" ? "white" : "black", // White text if active
                            borderRadius: "8px", // Optional: rounded corners
                            marginBottom: "8px", // Margin between items
                            width: "80%", // Optional: to create some width for the items
                            marginLeft: "auto", // Centers the item
                            marginRight: "auto", // Centers the item
                            "&:hover .MuiSvgIcon-root": { // Ensure the icon turns white on hover
                                color: "white",
                            },
                        }}
                    >
                        <ListItemIcon>
                            <BuildIcon sx={{ color: location.pathname === "/mantenimiento" ? "white" : "inherit" }} /> {/* White icon if active */}
                        </ListItemIcon>
                        <ListItemText primary="Mantenimiento" sx={{ color: "inherit" }} />
                    </ListItem>

                    {/* Consumo */}
                    <ListItem
                        button
                        component={Link}
                        to="/combustibles"
                        sx={{
                            cursor: "pointer",
                            background: location.pathname === "/combustibles" ? "#152d51" : "transparent",
                            "&:hover": {
                                backgroundColor: "#152d51", // Dark blue on hover
                                color: "white", // White text on hover
                            },
                            color: location.pathname === "/combustibles" ? "white" : "black", // White text if active
                            borderRadius: "8px", // Optional: rounded corners
                            marginBottom: "8px", // Margin between items
                            width: "80%", // Optional: to create some width for the items
                            marginLeft: "auto", // Centers the item
                            marginRight: "auto", // Centers the item
                            "&:hover .MuiSvgIcon-root": { // Ensure the icon turns white on hover
                                color: "white",
                            },
                        }}
                    >
                        <ListItemIcon>
                            <LocalGasStationIcon sx={{ color: location.pathname === "/combustibles" ? "white" : "inherit" }} /> {/* White icon if active */}
                        </ListItemIcon>
                        <ListItemText primary="Consumo" sx={{ color: "inherit" }} />
                    </ListItem>

                    {/* Viajes */}
                    {/*
                    <ListItem
                        button
                        component={Link}
                        to="/viajes"
                        sx={{
                            cursor: "pointer",
                            background: location.pathname === "/viajes" ? "#152d51" : "transparent",
                            "&:hover": {
                                backgroundColor: "#152d51", // Dark blue on hover
                                color: "white", // White text on hover
                            },
                            color: location.pathname === "/viajes" ? "white" : "black", // White text if active
                            borderRadius: "8px", // Optional: rounded corners
                            marginBottom: "8px", // Margin between items
                            width: "80%", // Optional: to create some width for the items
                            marginLeft: "auto", // Centers the item
                            marginRight: "auto", // Centers the item
                            "&:hover .MuiSvgIcon-root": { // Ensure the icon turns white on hover
                                color: "white",
                            },
                        }}
                    >
                        <ListItemIcon>
                            <TimerIcon sx={{ color: location.pathname === "/viajes" ? "white" : "inherit" }} />
                        </ListItemIcon>
                        <ListItemText primary="Viajes" sx={{ color: "inherit" }} />
                    </ListItem>
                    */}

                    {/* Infracciones */}
                    <ListItem
                        button
                        component={Link}
                        to="/infracciones"
                        sx={{
                            cursor: "pointer",
                            background: location.pathname === "/infracciones" ? "#152d51" : "transparent",
                            "&:hover": {
                                backgroundColor: "#152d51", // Dark blue on hover
                                color: "white", // White text on hover
                            },
                            color: location.pathname === "/infracciones" ? "white" : "black", // White text if active
                            borderRadius: "8px", // Optional: rounded corners
                            marginBottom: "8px", // Margin between items
                            width: "80%", // Optional: to create some width for the items
                            marginLeft: "auto", // Centers the item
                            marginRight: "auto", // Centers the item
                            "&:hover .MuiSvgIcon-root": { // Ensure the icon turns white on hover
                                color: "white",
                            },
                        }}
                    >
                        <ListItemIcon>
                            <LocalShippingIcon sx={{ color: location.pathname === "/infracciones" ? "white" : "inherit" }} /> {/* White icon if active */}
                        </ListItemIcon>
                        <ListItemText primary="Infracciones" sx={{ color: "inherit" }} />
                    </ListItem>

                    {/* Documentos */}
                    <ListItem
                        button
                        component={Link}
                        to="/documentos"
                        sx={{
                            cursor: "pointer",
                            background: location.pathname === "/documentos" ? "#152d51" : "transparent",
                            "&:hover": {
                                backgroundColor: "#152d51", // Dark blue on hover
                                color: "white", // White text on hover
                            },
                            color: location.pathname === "/documentos" ? "white" : "black", // White text if active
                            borderRadius: "8px", // Optional: rounded corners
                            marginBottom: "8px", // Margin between items
                            width: "80%", // Optional: to create some width for the items
                            marginLeft: "auto", // Centers the item
                            marginRight: "auto", // Centers the item
                            "&:hover .MuiSvgIcon-root": { // Ensure the icon turns white on hover
                                color: "white",
                            },
                        }}
                    >
                        <ListItemIcon>
                            <FolderIcon sx={{ color: location.pathname === "/documentos" ? "white" : "inherit" }} /> {/* White icon if active */}
                        </ListItemIcon>
                        <ListItemText primary="Documentos" sx={{ color: "inherit" }} />
                    </ListItem>
                </List>
            </Drawer>

        </>
    )
}

export default Sidebar;